import { observer } from "mobx-react-lite"

import type { Token } from "@/domains/core"
import type { VenammSellStore } from "@/domains/venamm"
import type { IVenammStore } from "@/domains/venamm"

import { VenammIdle } from "./1.venamm-idle"
import { VenammQuoting } from "./2.venamm-quoting"
import { VenammQuoteFailed } from "./3.venamm-quote-failed"
import { VenammQuoteReady } from "./3a.venamm-quote-ready"
import { VenammCheckingResetRequired } from "./4.venamm-checking-reset-required"
import { VenammResetRequired } from "./5.venamm-reset-required"
import { VenammResetting } from "./6.venamm-resetting"
import { VenammResetFailed } from "./7.venamm-reset-failed"
import { VenammCheckingApproval } from "./8.venamm-checking-approval"
import { VenammApproving } from "./9.venamm-approving"
import { VenammApproveFailed } from "./10.venamm-approve-failed"
import { VenammSelling } from "./11.venamm-selling"
import { VenammSellFailed } from "./12.venamm-sell-failed"
import { VenammComplete } from "./13.venamm-complete"

interface VenammStateComponentMapProps {
  store: VenammSellStore
  governanceToken: Token
  venammStore: IVenammStore
}

export const VenammStateComponentMap = observer(
  ({ store, governanceToken, venammStore }: VenammStateComponentMapProps) => {
    switch (store.state) {
      case "idle":
        return <VenammIdle store={store} />

      case "quoting":
        return <VenammQuoting store={store} />

      case "quote-ready":
        return <VenammQuoteReady store={store} governanceToken={governanceToken} venammStore={venammStore} />

      case "quote-failed":
        return <VenammQuoteFailed store={store} />

      case "checking-reset-required":
        return <VenammCheckingResetRequired store={store} />

      case "reset-required":
        return <VenammResetRequired store={store} />

      case "resetting":
        return <VenammResetting store={store} />

      case "reset-failed":
        return <VenammResetFailed store={store} />

      case "checking-approval":
        return <VenammCheckingApproval store={store} governanceTokenSymbol={governanceToken.symbol} />

      case "approving":
        return <VenammApproving store={store} />

      case "waiting-for-approval-confirmation":
        return <VenammApproving store={store} />

      case "approve-failed":
        return <VenammApproveFailed store={store} />

      case "selling":
        return <VenammSelling store={store} />

      case "sell-failed":
        return <VenammSellFailed store={store} />

      case "complete":
        return <VenammComplete store={store} governanceTokenSymbol={governanceToken.symbol} />

      default:
        return <div>Unknown state</div>
    }
  },
)
